import type { SvgSymbol } from '@app/types'

const importAll = (requireContext: __WebpackModuleApi.RequireContext): SvgSymbol[] =>
  requireContext.keys().map<SvgSymbol>(requireContext)

const requireContext = require.context('@app/assets/icons', false, /\.svg$/)

const svgSymbols = importAll(requireContext)

const svgSymbolIdList = svgSymbols.map(svgSymbol => svgSymbol?.default && svgSymbol.default.id).filter(id => id)

export default svgSymbolIdList
